export default __webpack_public_path__ + "static/media/Asset-81.50caf2c7.png";